import type {
    ArrayExtraFieldId,
    SimpleExtraFieldId,
} from './confirmShipmentDetailsWidget.types'

export const SIMPLE_EXTRA_FIELDS = [
    'specialInstructions',
    'numberOfShipments',
    'referenceId',
    'accessorials',
    'isRushedOrder',
    'isApprovalRequired',
] as const

export const ARRAY_EXTRA_FIELDS = [
    'extraPickupLocations',
    'extraDropoffLocations',
    'commodities',
] as const

export const EXTRA_FIELDS_OPTIONS: {
    id: SimpleExtraFieldId | ArrayExtraFieldId
    name: string
}[] = [
    {
        id: 'extraPickupLocations',
        name: 'Pickup location',
    },
    {
        id: 'extraDropoffLocations',
        name: 'Delivery location',
    },
    {
        id: 'numberOfShipments',
        name: 'Quantity',
    },
    {
        id: 'referenceId',
        name: 'Reference ID',
    },
    {
        id: 'specialInstructions',
        name: 'Special instructions',
    },
    {
        id: 'commodities',
        name: 'Commodity',
    },
    {
        id: 'accessorials',
        name: 'Accessorials',
    },
    {
        id: 'isRushedOrder',
        name: 'Rush order',
    },
    {
        id: 'isApprovalRequired',
        name: 'Approval required',
    },
]

export const DEFAULT_WIDTH = 40
export const DEFAULT_LENGTH = 48
export const DEFAULT_FREIGHT_TYPE = 'pallet'
